import { Render } from "../../../../../../../../homepage/Render";
import "./StoreCourseBenifits.scss";

export const StoreCourseBenifits = (props) => {
  const { packageData } = props;

  return (
    <Render if={packageData?.length > 0}>
      <div className="course-benefits-inner-wrapper">
        <h3>Course Benefits</h3>
        <div className="course-benefits-list">
          {packageData?.map((benefit, index) => (
            <div key={index} className="course-benefit-item">
              <img
                src={benefit.icon}
                alt={benefit.name}
                className="benefit-icon"
              />
              <span className="course-benefit-name">{benefit.name}</span>
            </div>
          ))}
        </div>
      </div>
    </Render>
  );
};
